import {
    Country, SupportedApplication
} from "@shopliftr/common-js/shared";
import packageInfo from "apps/admin/package.json";
import { IAppConfig } from "../app/common/interfaces/app-config";

/**
 * Invariant configuration shared by every admin environment.
 *
 * Environment-specific settings (URLs, telemetry, production/staging flags and
 * the Google Maps key) are declared explicitly in each concrete environment
 * file so that every config states its own effective settings. Login
 * credentials are intentionally NOT declared here — they are inlined per
 * environment so they are never bundled into builds that should not ship them
 * (e.g. production).
 */
export const environment: Pick<
    IAppConfig,
    "apiKeys" | "appVersion" | "appName" | "appLinks" | "authentication" | "flyerVersion" | "timezone"
> = {
    apiKeys: {
        defaultExclusions: {
            brands: [],
            chainIds: [
                "bd49c14a-0997-4448-9a95-83f9c8805b34",
                "438251e8-9519-455c-908d-ede84a3c6308",
                "5e4ee495-b3ed-47c0-880f-3f06f770c0ef",
                "b89375db-3dd2-4c4a-94d0-02d5f7f2a636",
                "ba823481-1d26-4447-babd-914525f36d0a",
                "2caac41e-ce0b-4c08-81d4-0c5d49d44fa8",
                "5b380c7a-c9e0-4393-a55a-5854201c3481",
                "96ee1c35-e934-4d41-933b-125b3aa7c4b8"
            ],
            countries: [Country.Canada],
            majorCategoryIds: ["53", "56", "37", "55", "58", "62", "63"],
            manufacturers: [],
            outputFilters: [],
            upcs: [],
            validations: []
        }
    },
    appVersion: packageInfo.version,
    appName: SupportedApplication.Admin,
    appLinks: [{
        title: "SMART",
        url: "https://smart.shopliftr.com",
        icon: "ads_click",
        roles: ["partner-admin"]
    }],
    authentication: {
        logoUrl: "/assets/images/logo-black-shopliftr.svg",
        heading: "Data Entry Portal"
    },
    flyerVersion: {
        elasticSearchDelay: 1000
    },
    timezone: "America/Chicago"
};
